import { fg } from '@atlaskit/platform-feature-flags/fg';

import { isUsingRovoConfigStoreExperiment } from '../../../../utils/is-using-rovo-config-store-experiment';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { generateCombinedConfigHash } from './generate-combined-config-hash';

export const GQL_OPERATION_NAME = 'searchCombinedConfig';

export const getSearchConfigQuery = () => `
query ${GQL_OPERATION_NAME}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          authResolutionMode
          connectorCreatedAt
          ${isUsingRovoConfigStoreExperiment() ? 'connectedAt' : ''}
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
        ${fg('rovo_fps_unit_metadata') ? 'unitMetadata { id siteName url }' : ''}
    }
  }
}`;
